<template>
  <alerts :activeAlert="activeAlert" />
</template>

<script>
const activeAlert = {
  type: "danger",
  title: "Hemos recibido tu pago",
  message:
    "Tu perfil se activará en unos minutos.  Guarda nuestro whatsapp por si necesitas ayuda +34 643658547",
  classes: "bg-blue-linear",
  headingClasses: "text-white",
  textClasses: "text-white-0-75",
  status: false,
  to: {
    path: "/",
    query: null,
  },
}
import Alerts from "@/components/UI/Partials/Alerts"
export default {
  data() {
    return {
      activeAlert,
    }
  },
  components: { Alerts },
}
</script>

<style></style>
